import { Img, Lightning, Utils } from '@lightningjs/sdk'

export default class AlbumCover extends Lightning.Component {
  static _template() {
    return {
      w: 540,
      h: 540,
      CoverWrapper: {
        w: 540,
        h: 540,
        CoverImageWrapper: {
          w: 540,
          h: 540,
          CoverBG: {
            w: 540,
            h: 540,
            src: Utils.asset('images/covers/ImagePlaceHolder.jpg'),
          },
          Cover: { w: 540, h: 540 },
        },
      },
    }
  }

  set item(itm) {
    this.tag('CoverImageWrapper').patch({
      Cover: { texture: Img(itm).cover(540 / 2, 540 / 2) }, // todo resize to original
    })
  }
  set itemBg(v) {
    this.tag('CoverBG').patch({
      texture: Img(v).cover(540 / 2, 540 / 2), // todo resize to original
    })
  }

  _init() {
    // this.tag('CoverBG').on('txLoaded', () => {
    // 	this.tag('CoverShadow').patch({
    // 		smooth: {alpha: [0.4, {duration: 0.2, timingFunction: 'ease-in'}]}
    // 	});
    // });
    this.tag('Cover').on('txLoaded', () => {
      this.stage.gc()
    })
  }
}
